import { Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

export abstract class RenterForm {
  protected _disable: boolean = false;

  @Input() set disable(value: boolean) {
    this._disable = value;

    if (value) {
      this.userFormDisable();
    } else {
      this.userFormEnable();
    }
  }

  get disable(): boolean {
    return this._disable;
  }

  @Input() photos: boolean = true;

  abstract get form(): FormGroup;

  protected userFormDisable() {
    this.form.disable();
  }

  protected userFormEnable() {
    this.form.enable();
  }
}
